import React from "react"
import ResetPasswordPage from "../pages/ResetPasswordPage"
import { initReactApp } from "../utils/init"

initReactApp(<ResetPasswordPage/>)
